const route = "settings";

export default {
  methods: {
    //guestbook
    SettingApi_getAllSettingGuestbook(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/guestbook`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_createSettingGuestbook(data) {
      return this.$http({
        method: "post",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/guestbook`,
        data: data,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_updateSettingGuestbook(id, data) {
      return this.$http({
        method: "post",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/guestbook/` +
          id +
          "/update",
        data: data,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_deleteSettingGuestbook(id) {
      return this.$http({
        method: "post",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/guestbook/` +
          id +
          "/delete",
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    // rate
    SettingApi_getAllSettingRate() {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/rating`,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_getParentSettingRate(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/rating/parent-id`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_updateSettingRate(id, data) {
      return this.$http({
        method: "post",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/rating/` +
          id +
          "/update",
        data: data,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    //region
    SettingApi_getAllSettingRegion(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/region`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    //agenda
    SettingApi_getAllSettingAgenda(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/agenda`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_createSettingAgenda(data) {
      return this.$http({
        method: "post",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/agenda`,
        data: data,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_updateSettingAgenda(id, data) {
      return this.$http({
        method: "post",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/agenda/` +
          id +
          "/update",
        data: data,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_deleteSettingAgenda(id) {
      return this.$http({
        method: "post",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/agenda/` +
          id +
          "/delete",
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    //paper-size
    SettingApi_getAllSettingPaperSize(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/paper-size`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_getAllOnlyMaster(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/master/parent`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_parentMaster(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `public/master/parent`,
        params: params,
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_getAllOnlyChildMaster(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/master/child`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_createSettingMaster(data) {
      return this.$http({
        method: "post",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/master`,
        data: data,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_updateSettingMaster(id, data) {
      return this.$http({
        method: "post",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/master/` +
          id +
          "/update",
        data: data,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_deleteSettingMaster(id) {
      return this.$http({
        method: "post",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/master/` +
          id +
          "/delete",
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    //signage
    SettingApi_getAllSettingSignage(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/signage`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_createSettingSignage(data) {
      return this.$http({
        method: "post",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/signage`,
        data: data,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_updateSettingSignage(id, data) {
      return this.$http({
        method: "post",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/signage/` +
          id +
          "/update",
        data: data,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_deleteSettingSignage(id) {
      return this.$http({
        method: "post",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/signage/` +
          id +
          "/delete",
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    //invitation document
    SettingApi_getAllSettingUnvitation(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/invitation-documen`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_createSettingUnvitation(params) {
      return this.$http({
        method: "post",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/invitation-documen`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    //citizen
    SettingApi_getStatistiCitizen(params) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/citizen-master`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    //download
    SettingApi_downloadReligion() {
      return this.$http({
        method: "get",
        responseType: "blob",
        url: process.env.VUE_APP_API_ENDPOINT + `${route}/download/statistic`,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    //document Number
    SettingApi_documentNumber() {
      return this.$http({
        method: "get",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/document-number/division`,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_documentNumberByCode(code) {
      return this.$http({
        method: "get",
        url:
          process.env.VUE_APP_API_ENDPOINT + `${route}/document-number/` + code,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    SettingApi_documentNumberGenerate(params) {
      return this.$http({
        method: "get",
        url:
          process.env.VUE_APP_API_ENDPOINT +
          `${route}/document-number/generate`,
        params: params,
        headers: {
          Authorization: `Bearer ${this.AuthorizationToken}`,
        },
      })
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          this.HandleAxiosError(error, true);
          return error;
        });
    },

    //request link
    SettingApi_url(code) {
      return this.$http({
        method: "get",
        url: process.env.VUE_APP_API_ENDPOINT + `public/validate-url/` + code,
      })
        .then(({ data }) => {
          return data;
        })
        .catch(() => {
          // this.HandleAxiosError(error, true);
          this.$router.push("/public/not-found");
        });
    },
  },
};
